import React, { FC } from 'react'
import { Switch, SwitchProps } from '@mui/material'

export const EvtSwitch: FC<SwitchProps> = ({ ...props }) => {
    return <Switch {...props} />
}

export default EvtSwitch
